import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { CoreService } from "./core.service";
import { API } from "./paymentapiroutes";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private apiService: ApiService) {}

  AddAddress(data: any): Observable<any> {
    return this.apiService.post(API.ADD_USER_ADDRESS, data);
  }
  UpdateAddress(id: any, data: any): Observable<any> {
    return this.apiService.put(API.ADD_USER_ADDRESS + "/" + id, data);
  }
  DeleteAddress(id: any): Observable<any> {
    return this.apiService.delete(API.ADD_USER_ADDRESS + "/" + id);
  }
  GetUserProfile() {
    return this.apiService.get(API.GET_USER_PROFILE);
  }

  GetSelectedLocation(): Observable<any> {
    var userId;
    if (localStorage.getItem("currentUser")) {
      var currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
      if (currentUser?.user) {
        userId = currentUser?.user?.id;
      }
    }

    if (userId != undefined) {
      return this.apiService.get(
        API.GETSELECTEDLOCATION +
          "?user_id=" +
          userId +
          "&retailer_id=" +
          CoreService.retailerId
      );
    }
  }

  SetSelectedLocation(data: any): Observable<any> {
    var Request = {};

    var userId;
    var Request = {};
    if (localStorage.getItem("currentUser")) {
      var currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
      if (currentUser?.user) {
        userId = currentUser?.user?.id;
      }
    }

    if (userId != undefined) {
      if (data.is_user_location) {
        Request = {
          table_id: data.table_id,
          user_address_id: data.address_id,
          user_id: userId,
          retailer_id: CoreService.retailerId,
        };
      } else {
        Request = {
          table_id: data.table_id,
          retailer_address_id: data.address_id,
          user_id: userId,
          retailer_id: CoreService.retailerId,
        };
      }
      // var data = this.apiService.post(
      //   API.STOREBASKET +
      //     "?user_id=" +
      //     userId +
      //     "&retailer_id=" +
      //     CoreService.retailerId,
      //   Request
      // );
    }

    return this.apiService.post(API.SETSELECTEDLOCATION, Request);
  }

  GetUserTokenTransaction() {
    return this.apiService.get(API.GETUSERTOKENTRANSACTION);
  }
  GetUserTokenBalance() {
    return this.apiService.get(API.GETUSERTOKENBALANCE);
  }
}
